// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"c7e73e55","261":"0e1c2c0f","703":"aa9bb986","743":"9e252b93","790":"94be0d01","845":"888dbdae"}[chunkId] + ".chunk.js";
};